'use client';
import { useContext, useEffect } from 'react';
import { SessionContext } from '@benzinga/session-context';
import { usePermission } from '@benzinga/user-context';
import { TrackingManager } from '@benzinga/tracking-manager';

export const SectionPaywall = ({ section, symbol }: { section: string; symbol: string }) => {
  const session = useContext(SessionContext);
  const hasPermission = usePermission('com/reports', '#');
  const paywallId = `stock-report-${section}-paywall-${symbol}`;
  const paywallCampaign = 'score-locked';
  const adType = 'stock-report';

  const baseCheckoutUrl = 'https://www.benzinga.com/premium/ideas/benzinga-edge';
  const urlParams = new URLSearchParams({
    utm_adType: adType,
    utm_campaign: paywallCampaign,
  });

  const checkoutUrl = `${baseCheckoutUrl}?${urlParams.toString()}`;

  useEffect(() => {
    if (!hasPermission) {
      session.getManager(TrackingManager).trackPaywallEvent('view', {
        paywall_id: paywallId,
        paywall_type: 'hard',
        placement: `stock-report-${section}`,
        utmParams: {
          adType: adType,
          campaign: paywallCampaign,
        },
      });
    }
  }, [hasPermission, paywallId, paywallCampaign, session, section]);

  if (hasPermission) {
    return null;
  }

  return (
    <a
      className={`absolute top-0 left-0 bg-bzblue-200 p-2 w-full h-full flex flex-col items-center justify-center gap-4 stock-report-${section}-paywall text-bzblue-900`}
      href={checkoutUrl}
      target="_blank"
    >
      <div className="text-xl section-paywall-title">Stock Score Locked: Want to See it?</div>
      <div className="section-paywall-subtitle">Benzinga Rankings give you vital metrics on any stock – anytime.</div>
      <div>
        <button className="bg-bzblue-700 text-white rounded-md p-2 section-paywall-button">Unlock Rankings</button>
      </div>
    </a>
  );
};
